import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=47b062a0&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=ts&"
export * from "./Configuration.vue?vue&type=script&lang=ts&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=47b062a0&prod&lang=scss&"
import style1 from "./Configuration.vue?vue&type=style&index=1&id=47b062a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b062a0",
  null
  
)

export default component.exports